import { applicationBuilder, GetApplicationPages, GetApplicationState } from "../../Shared/Frontend/application-discovery/module";
import { publicSiteModule } from "./publicSite/publicSite.module";

export const application = 
  applicationBuilder
    .addModule(publicSiteModule)

export type ApplicationBuilderState = typeof application
export type ApplicationState = GetApplicationState<ApplicationBuilderState>
export type ApplicationPages = GetApplicationPages<ApplicationBuilderState>
